import { useState } from "react";
import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import { PRODUCT, formatPrice, getColor, productUrl } from "../../data/catalog";
import { Swatches } from "./Swatches";

export const ProductCard = ({ colorId, onQuickView, prefix = "card" }) => {
  const [cid, setCid] = useState(colorId);
  const c = getColor(cid);
  const tid = `${prefix}-${colorId}`;
  return (
    <article className="group" data-testid={`product-card-${tid}`}>
      <Link to={productUrl(c.id)} className="relative block aspect-[4/5] overflow-hidden bg-white" data-testid={`product-card-link-${tid}`}>
        <img src={c.image} alt={`${PRODUCT.name} in ${c.name}`} loading="lazy"
          className="absolute inset-0 h-full w-full object-contain p-6 transition-[transform,opacity] duration-700 ease-out group-hover:scale-[1.04] md:group-hover:opacity-0" />
        <img src={c.life} alt="" loading="lazy"
          className="absolute inset-0 hidden h-full w-full scale-105 object-cover object-bottom opacity-0 transition-[transform,opacity] duration-700 ease-out group-hover:scale-100 group-hover:opacity-100 md:block" />
        <span className="absolute left-4 top-4 bg-ivory/90 px-2 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-ink">New</span>
        <button
          onClick={(e) => { e.preventDefault(); onQuickView?.(c.id); }}
          data-testid={`quick-view-${tid}`}
          className="absolute bottom-3 right-3 flex h-10 w-10 items-center justify-center gap-2 rounded-full bg-ivory/95 text-[11px] font-medium uppercase tracking-[0.2em] text-ink backdrop-blur transition-[opacity,transform] duration-500 md:inset-x-4 md:bottom-4 md:h-auto md:w-auto md:translate-y-3 md:rounded-none md:py-3 md:opacity-0 md:group-hover:translate-y-0 md:group-hover:opacity-100"
        >
          <Eye className="h-4 w-4" /> <span className="hidden md:inline">Quick view</span>
        </button>
      </Link>
      <div className="mt-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-display text-xl leading-tight text-ink">{PRODUCT.name}</h3>
          <p className="text-xs text-graphite">{c.name}</p>
        </div>
        <span className="text-sm text-ink">{formatPrice(PRODUCT.price)}</span>
      </div>
      <div className="mt-3"><Swatches value={cid} onChange={setCid} prefix={tid} size="sm" /></div>
    </article>
  );
};
